import { GetServerSidePropsContext } from 'next';
import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import React, { useEffect } from 'react';
import { store, StoreContext } from 'stores/store';
import UnsubscribeWrapper from 'templates/Unsubscribe/UnsubscribeWrapper/UnsubscribeWrapper';
import { IAuthDetails, verifyAuth } from 'utils/authUtils';
import { getConfigEntry } from 'utils/contentClient';
import { IResourceData } from 'utils/globalTypes';
import UseSsrAuth from 'utils/hooks/useSsrAuth';
import { useUserAuth } from 'utils/hooks/useUserAuth';
import { getObjProperty } from 'utils/object';

function Unsubscribe({
  images,
  authDetails
}: {
  images?: IResourceData[];
  authDetails: IAuthDetails;
}) {
  const { publicRuntimeConfig } = getConfig();
  const { NEXT_PUBLIC_DOMAIN } = publicRuntimeConfig;

  const title = 'USREM | Unsubscribe';
  const url = `https://${NEXT_PUBLIC_DOMAIN}/unsubscribe`;
  const description = 'Unsubscribe from USREM | USREM';

  const clientAuthDetails = useUserAuth();

  useEffect(() => {
    verifyAuth(authDetails, clientAuthDetails);
  }, [authDetails, clientAuthDetails]);

  return (
    <>
      <NextSeo
        title={title}
        canonical={url}
        openGraph={{
          title: title,
          url: url,
          description
        }}
      />
      <StoreContext.Provider value={{ ...store }}>
        <UnsubscribeWrapper images={images} />
      </StoreContext.Provider>
    </>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const authProps = await UseSsrAuth(ctx);
  const content = await getConfigEntry('pages/unsubscribe');
  const unsubscribeImages = getObjProperty(content as Record<string, unknown>, 'media') || [];

  return {
    props: { ...authProps.props, images: unsubscribeImages ?? null }
  };
}

export default Unsubscribe;
